import { render, staticRenderFns } from "./CorporateActivityOperationalLimits.vue?vue&type=template&id=8b62dcb0&scoped=true"
import script from "./CorporateActivityOperationalLimits.vue?vue&type=script&lang=js"
export * from "./CorporateActivityOperationalLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b62dcb0",
  null
  
)

export default component.exports